import React from 'react';
import { Row, Divider, Col, Space } from 'antd';
import styled from 'styled-components';
import Link from 'next/link';
import parse from 'html-react-parser';
import Section from 'components/Section';

interface Props {
    tableOfContent: ToC[];
}

const ToCTitle = styled.h2`
    font-size: 20px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.3;
    letter-spacing: normal;
    text-align: left;
    color: ${({ theme }) => theme.colors.primary};
`;

const ToCSubTitle = styled.p`
    font-size: 14px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.3;
    letter-spacing: normal;
    text-align: left;
    margin: 0;
    color: ${({ theme }) => theme.colors.brownishGrey};
`;

const ToCArticleTitle = styled.p`
    font-size: 16px;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.3;
    letter-spacing: normal;
    text-align: left;
    margin-bottom: 0;
    color: ${({ theme }) => theme.colors.brownishGrey};
    > a {
        color: ${({ theme }) => theme.colors.brownishGrey};
        text-decoration: underline;
        :hover {
            color: ${({ theme }) => theme.colors.primary};
        }
    }
`;

const ToCPage = styled.p`
    font-size: 22px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.3;
    letter-spacing: normal;
    text-align: left;
    padding: 12px;
    margin: 0;
    color: ${({ theme }) => theme.colors.brownishGrey};
`;

const ToCWrapper = styled.div`
    width: 100%;
`;

export const Content = ({ tableOfContent }: Props): React.JSX.Element => (
    <Row id="table-of-content">
        <Col span={24}>
            {tableOfContent.map((content) => (
                <Section gutter={[16, 16]} key={content.title}>
                    <Col span={24}>
                        <Row>
                            <Col sm={18} md={10}>
                                <ToCTitle>{parse(content.title)}</ToCTitle>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={0} md={10}></Col>
                            <Col sm={24} md={14}>
                                <Space
                                    style={{ width: '100%' }}
                                    split={<Divider style={{ margin: 0 }} />}
                                    direction="vertical"
                                >
                                    {content.sections.map((section) =>
                                        section.articles.map((article) => (
                                            <Row wrap={false} key={article.title}>
                                                <Col flex="50px">
                                                    <ToCPage>{article.page}</ToCPage>
                                                </Col>
                                                <Col flex="auto">
                                                    <ToCWrapper>
                                                        {article.title && (
                                                            <ToCArticleTitle>
                                                                {article.url ? (
                                                                    <Link href={article.url}>
                                                                        {parse(article.title)}
                                                                    </Link>
                                                                ) : (
                                                                    parse(article.title)
                                                                )}
                                                            </ToCArticleTitle>
                                                        )}
                                                        <ToCSubTitle>{section.title}</ToCSubTitle>
                                                    </ToCWrapper>
                                                </Col>
                                            </Row>
                                        ))
                                    )}
                                </Space>
                            </Col>
                        </Row>
                    </Col>
                </Section>
            ))}
        </Col>
    </Row>
);

export default Content;
